// extracted by mini-css-extract-plugin
module.exports = {"card":"Text_card__298Db","buttons":"Text_buttons__2GVYp","prices":"Text_prices__uF14Z","text":"Text_text__2cOWn"};